import {
  NEWS_REQUEST, NEWS_REQUEST_SUCCESS, NEWS_REQUEST_FAILED
} from "../actions/news_actions";

const initialState = {
  count: 0,
  pages: 0,
  next: null,
  previous: null,
  news: []
};

export const newsReducer = (state = initialState, action) => {
  switch (action.type) {
    case NEWS_REQUEST: {
      return {
        ...state
      }
    }
    case NEWS_REQUEST_SUCCESS: {
      return {
        ...state,
        count: action.payload.count,
        pages: action.payload.pages,
        next: action.payload.links.next,
        previous: action.payload.links.previous,
        news: [...action.payload.results]
      }
    }
    case NEWS_REQUEST_FAILED: {
      return {
        ...state,
        count: 0,
        pages: 0,
        next: null,
        previous: null,
        news: []
      }
    }
    default: return state;
  }
}
